export default __webpack_public_path__ + "static/codingpark-web-ide-442001005630cb6a9a66e9bd18d790bd.png";